var render, staticRenderFns
import script from "./EstimateDetailContent.vue?vue&type=script&lang=ts&"
export * from "./EstimateDetailContent.vue?vue&type=script&lang=ts&"
import style0 from "./EstimateDetailContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EstimateDetailContent.vue?vue&type=style&index=1&id=f947f828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f947f828",
  null
  
)

export default component.exports